import { createSlice } from '@reduxjs/toolkit'
import { type RootState } from '@/store/models/state'

interface IUserProfileState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userCredentials?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userProfile?: any
}

const initialState = {} as IUserProfileState

export const slice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.userProfile = action.payload
    },
    setUserCredentials: (state, action) => {
      state.userCredentials = action.payload
    },
  },
})

export const { setUserProfile, setUserCredentials } = slice.actions

export const getUserProfile = (state: RootState) =>
  state.userProfile.userProfile

export const getUserCredentials = (state: RootState) =>
  state.userProfile.userCredentials

export default slice.reducer
